import styled from '@emotion/styled'

export const StyledFeesBox = styled.div`
  border-radius: 4px;
  background: var(--White);
`
